export const EMAIL = "danishraza0333@gmail.com"